// extracted by mini-css-extract-plugin
module.exports = {"styledAccordion":"uh3CrFJd"};